const $inject = ['SCT_CONFIG'];

const userRoleNameFilter = (SCT_CONFIG) => {
  return (roleID) => {
    return SCT_CONFIG.roles[roleID] || '';
  }
};

userRoleNameFilter.$inject = $inject;

export default userRoleNameFilter;




// WEBPACK FOOTER //
// ./src/filters/userRoleNameFilter.js